<template>
    <div style="height: 100%;">
        <div class="set-item">
            <div style="margin-bottom: 3rem;">参考教材</div>
            <div class="box-ev">
                <div class="book-box">
                    <div class="border-line"></div>
                    <p class="book-name-t">教材名称</p>
                    <p class="book-pic-t">描述</p>
                    <p class="pic">上传图片</p>
                    <div class="add-btn el-icon-plus" :class="{'disabled-btn':disabled}" @click="add"></div>
                    <div class="item-box">
                        <div v-for="(item, index) in referencePOList" :key="index">
                            <div class="book-item">
                                <el-input :disabled="disabled" v-model="item.name" style="width: 20rem;" placeholder="请输入内容"></el-input>
                                <el-input :disabled="disabled" v-model="item.describe" style="width: 50rem;margin-right: 2rem;"
                                    placeholder="请输入描述"></el-input>
                                <el-upload :disabled="disabled" style="width: 40px !important; height: 40px !important" action="#"
                                    accept=".jpg,.jpeg,.png" list-type="picture-card" :auto-upload="false"
                                    :show-file-list="false" class="upload-box-img" :on-change="(e) => { handleFm(e, item) }">
                                    <img v-if="item.coverPath" :src="$severUrl(item.coverPath)"
                                        style="width: 38px; height: 38px;object-fit: cover;" />
                                    <i v-if="!item.coverPath" class="el-icon-plus"></i>
                                </el-upload>
                                <el-upload :disabled="disabled" style="margin-left: 2rem;" class="upload-demo" ref="upload" action="#"
                                    :on-change="(e) => { changeUpload(e, item) }" :show-file-list="false"
                                    :auto-upload="false">
                                    <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
                                </el-upload>
                                <div v-if="percentage(item) > 0 && percentage(item) < 100"
                                    style="width: 20rem;margin-left: 1rem;">
                                    <el-progress :percentage="percentage(item)"></el-progress>
                                </div>
                                <el-tooltip v-else class="item" effect="dark" :content="item.fileName"
                                    placement="top-start">
                                    <div class="overflow" style="margin-left: 0.5rem;width: 17rem;">{{ item.fileName }}
                                    </div>
                                </el-tooltip>
                                <el-tooltip v-if="item.fileName" class="item" effect="dark" content="删除文件"
                                    placement="top-start">
                                    <i class="iconfont icon-shanchu" :class="{'disabled-btn':disabled}" style="cursor: pointer;"
                                        @click="delFile(item)"></i>
                                </el-tooltip>
                                <i class="el-icon-close close" :class="{'disabled-btn':disabled}" @click="delItem(index)"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="save-box">
            <el-button type="primary" size="large" :class="{'disabled-btn':disabled}" v-debounce="save">保存</el-button>
        </div>
    </div>
</template>
<script>
import { uploadFile } from '@/assets/js/oss';
import { GetList, UpdateCourseReference } from '@/api/textBook';
import UploadChunk from '../../common/UploadChunk.vue';
import SparkMD5 from 'spark-md5';
import { chunkInit, chunkUpload } from '@/api/file/commonFile';
export default {
    components: { UploadChunk },
    props: ['form','disabled'],
    data() {
        return {
            referencePOList: [],
            chunkSize: 1024 * 1024 * 3
        }
    },
    computed: {
        courseId() {
            return this.$store.state.course.currentCourseId || this.$route.query.id || '';
        }
    },
    methods: {
        add() {
            if(this.disabled)return;
            var obj = {
                "name": '',
                "coverPath": "",
                "fileId": "",
                "describe": '',
                "fileName": "",
                "fileUrl": "",
                "file": '',
                "currentChunk": "",
                "chunkCount": "",
                "initFileData": "",
                "md5": ""
            };
            this.referencePOList.push(obj);
        },
        /**删除文件 */
        delFile(item) {
            if(this.disabled)return;
            item.fileId = '';
            item.fileName = '';
            item.fileUrl = '';
        },
        percentage(item) {
            if (item.currentChunk && item.chunkCount){
              return Math.round(item.currentChunk / item.chunkCount * 100);
            } else{
              return 0;
            }

        },
        async changeUpload(e, item) {
            var file = e.raw;
            item.file = file;
            item.currentChunk = 0;
            this.$set(item, 'chunkCount', Math.ceil(file.size / this.chunkSize));
            if (file.size < 2 * 1024 * 1024) {
                uploadFile(e.raw).then(res => {
                    this.$msg({
                        showClose: true,
                        message: "上传成功",
                        type: "success",
                    });
                    item.fileId = res.id;
                    item.fileUrl = res.fileUrl;
                    item.fileName = res.fileName;
                })
                return;
            }
            await this.fileMd5Sum(file, item);
            await this.initUpload(file, item);
            if (item.initFileData.secondUpload) {
                this.$msg({
                    showClose: true,
                    message: "上传成功",
                    type: "success",
                });
                item.fileId = item.initFileData.id;
                item.fileUrl = item.initFileData.fileUrl;
                item.fileName = item.initFileData.fileName;
                return;
            }
            this.loadingUpload(item);
        },
        /**处理分片 */
        uploadChunk(item, index) {
            // 计算分片的起始和结束字节
            let start = (index - 1) * this.chunkSize;
            let end = Math.min(item.file.size, start + this.chunkSize);
            // 将分片读取为Blob
            let chunk = item.file.slice(start, end);
            // 创建FormData并附加分片
            let formData = new FormData();
            formData.append('chunkNumber', index);
            formData.append('chunkSize', end - start);
            formData.append('file', chunk);
            formData.append('fileExt', item.initFileData.fileExt);
            formData.append('fileKey', item.initFileData.fileKey);
            formData.append('fileName', item.file.name);
            formData.append('fileSearch', item.initFileData.fileSearch);
            formData.append('fileSize', item.file.size);
            formData.append('md5', item.initFileData.md5);
            formData.append('secondUpload', item.initFileData.secondUpload);
            formData.append('totalChunks', item.chunkCount);
            formData.append('uploadId', item.initFileData.uploadId);
            return formData
        },
        loadingUpload(item, i = item.currentChunk + 1) {
            let params = this.uploadChunk(item, i);
            chunkUpload(params).then(res => {
                this.$set(item, 'currentChunk', i);
                i++;
                if (item.currentChunk >= item.chunkCount) {
                    this.$msg({
                        showClose: true,
                        message: "上传成功",
                        type: "success",
                    });
                    item.fileId = res.data.id;
                    item.fileUrl = res.data.fileUrl;
                    item.fileName = res.data.fileName;
                    return;
                }
                this.loadingUpload(item, i);
            })
        },
        /**上传初始化 */
        initUpload(file, item) {
            return new Promise((resolve) => {
                var params = {
                    "fileName": file.name,
                    "fileSearch": true,
                    "fileSize": file.size,
                    "md5": item.md5
                };
                chunkInit(params).then(res => {
                    if (res.code == 200) {
                        item.initFileData = res.data;
                        if (res.data.chunkDataList && res.data.chunkDataList.length > 0) {
                            item.currentChunk = res.data.chunkDataList.length;
                        }
                        resolve(res);
                    }
                });
            })
        },
        /**MD5加密 */
        fileMd5Sum(file, item) {
            return new Promise((resolve) => {
                const fileReader = new FileReader()
                fileReader.readAsBinaryString(file);
                fileReader.onload = e => {
                    const md5 = SparkMD5.hashBinary(e.target.result);
                    item.md5 = md5;
                    resolve(md5);
                }
            })
        },

        /**课程参考资料查询 */
        selectReference() {
            var params = {
                "courseId": this.courseId,
            }
            GetList(params).then(res => {
                if (res.code == 200) {
                    this.referencePOList = res.data;
                }
            })
        },
        /**保存 */
        save() {
            if(this.disabled)return;
            this.referencePOList.forEach(item => {
                delete item.file;
                delete item.currentChunk;
                delete item.chunkCount;
                delete item.initFileData;
                delete item.md5;
            })
            var params = {
                courseId: this.courseId,
                courseReferenceUpdatePOS: this.referencePOList,
            }
            UpdateCourseReference(params).then(res => {
                if (res.code == 200) {
                    this.$msg({
                        showClose: true,
                        message: "保存成功",
                        type: "success",
                    });
                }
                this.$emit('save_success');
            })
        },
        /**上传封面 */
        handleFm(e, item) {
            uploadFile(e.raw).then(res => {
                if (res) {
                    item.coverPath = res.previewUrl;
                }
            })
        },
        delItem(index) {
            if(this.disabled)return;
            this.referencePOList.splice(index, 1);
        }
    }
}
</script>

<style lang="less" scoped>
.set-item {
    margin-top: 3rem;
    height: calc(100% - 10.8rem);
}

.add-btn {
    width: 4rem;
    height: 4rem;
    background: #387dff;
    border-radius: 10px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
    margin-left: 3rem;
}

.chunk-upload-box {
    width: 40rem;
}

.upload-box-img {
    /deep/.el-upload {
        width: 40px;
        height: 40px;
        position: relative;
    }

    /deep/.el-upload--picture-card {
        border: 1px solid #e8ecef;
        background: #ffffff;
    }
}
.box-ev{
    height: calc(100% - 8rem);
    overflow: auto;
}
.book-box {
    display: flex;
    align-items: center;
    position: relative;
    padding-top: 3rem;
    .item-box {
        flex: 1;
    }

    .book-item {
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;

        .el-icon-close {
            margin-left: 5rem;
            cursor: pointer;
            border-radius: 50%;
            background-color: red;
            width: 2rem;
            height: 2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
        }

        .close {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
        }

        &> :nth-child(1) {
            margin-right: 1.5rem;
        }
    }
}

.upload-box-img {
    /deep/.el-icon-plus {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 1rem;
    }
}

.item-box {
    margin-left: 3rem;

    &> :nth-child(n) {
        margin-top: 1rem;
    }

    &> :nth-child(1) {
        margin-top: 0;
    }
}

.border-line {
    background-color: #387DFF;
    width: 4px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 2px;
}

.book-name-t {
    position: absolute;
    top: 0rem;
    left: 10rem;
}

.pic {
    position: absolute;
    top: 0rem;
    left: 83.5rem;
}

.book-pic-t {
    position: absolute;
    top: 0rem;
    left: 31.5rem;
}

/deep/.el-textarea__inner {
    height: 100%;
}

.save-box {
    padding: 3rem;
    text-align: center;
}
</style>